import {
  ReadonlyWatchable,
  Watchable,
} from '@cotera/client/v0/actions/framework';
import { WorkflowEntityNodeModel } from './workflow-entity-node-model';

export type CronTriggerNodeSnapshot = {
  readonly id: string;
  readonly name: string;
  readonly cron: string;
  readonly timezone: string;
  readonly enabled: boolean;
};

/**
 * Per-node view model for cron triggers on the workflow canvas. State is
 * derived from the workflow graph snapshot (updated when the draft graph syncs).
 */
export class WorkflowCronTriggerNodeModel extends WorkflowEntityNodeModel {
  readonly triggerId: string;
  readonly snapshotWatchable: ReadonlyWatchable<CronTriggerNodeSnapshot>;
  readonly scheduleWatchable: ReadonlyWatchable<string>;
  readonly timezoneWatchable: ReadonlyWatchable<string>;

  private readonly _snapshotWatchable: Watchable<CronTriggerNodeSnapshot>;

  constructor(triggerId: string, snapshot: CronTriggerNodeSnapshot) {
    super(triggerId);
    this.triggerId = triggerId;
    this._snapshotWatchable = Watchable.fromValue(snapshot);
    this.snapshotWatchable = this._snapshotWatchable;
    this.scheduleWatchable = Watchable.from(
      (get) => get(this._snapshotWatchable).cron
    );
    this.timezoneWatchable = Watchable.from(
      (get) => get(this._snapshotWatchable).timezone
    );
  }

  updateSnapshot(snapshot: CronTriggerNodeSnapshot): void {
    this._snapshotWatchable.set(snapshot);
  }

  dispose(): void {}
}
